import { render, staticRenderFns } from "./drugItem.vue?vue&type=template&id=40d8bf93&scoped=true"
import script from "./drugItem.vue?vue&type=script&lang=js"
export * from "./drugItem.vue?vue&type=script&lang=js"
import style0 from "./drugItem.vue?vue&type=style&index=0&id=40d8bf93&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d8bf93",
  null
  
)

export default component.exports